import { render, staticRenderFns } from "./item-child-grid.vue?vue&type=template&id=f9f79934"
import script from "./item-child-grid.vue?vue&type=script&lang=ts"
export * from "./item-child-grid.vue?vue&type=script&lang=ts"
import style0 from "./item-child-grid.vue?vue&type=style&index=0&id=f9f79934&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9f79934')) {
      api.createRecord('f9f79934', component.options)
    } else {
      api.reload('f9f79934', component.options)
    }
    module.hot.accept("./item-child-grid.vue?vue&type=template&id=f9f79934", function () {
      api.rerender('f9f79934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/item-child-grid.vue"
export default component.exports